export const uploadTranslation = {
  fi: {
    Upload: {
      networkError:
        'Kuvan lähetys epäonnistui (verkkovirhe). Tarkista yhteys ja yritä uudelleen.',
      unknownError: 'Kuvan lähetys epäonnistui.',
      imageMaxSizeExceeded: 'Kuvan enimmäiskoko on 10 Mt.',
      attachmentMaxSizeExceeded: 'Liitteen enimmäiskoko on 10 Mt.',
    },
  },
}
